<div class="container-xxl gx-sm-9 gx-lg-10 gx-xxl-0">
    <div class="row mb-8 mb-xl-0">
        <div class="col-12 col-lg-4 d-flex flex-column justify-content-center">
            <h3 class="mb-3 fs-29 fw-700" [innerHtml]="'ABOUT_US.title' | translate"></h3>
            <p class="mb-3 lh-29" [innerHtml]="'ABOUT_US.content_full_p1' | translate"></p>
        </div>
        <div class="col-12 col-lg-8">
            <div class="row gx-3 gx-sm-5">
                <div class="col-4">
                    <div class="h-100 overflow-hidden">
                        <img class="min-w-100 min-h-100 img-fluid item-md-center" src="/assets/images/building.png" alt="" />
                    </div>
                </div>
                <div class="col-4">
                    <div class="h-100 overflow-hidden">
                        <img class="min-w-100 min-h-100 img-fluid item-md-center" src="/assets/images/office.png" alt="" />
                    </div>
                </div>
                <div class="col-4">
                    <div class="h-100 overflow-hidden">
                        <img class="min-w-100 min-h-100 img-fluid item-md-center" src="/assets/images/hall.png" alt="" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
